

















































import { Vue, Component, Prop } from 'vue-property-decorator';
import { redirect, Routes } from '../../shared/router';
import { UserInfo } from '../../shared/user';
import { store, bus, signout, client } from '../../shared';
@Component({})
export default class Landing extends Vue {
    urlParameterText: any = '';
    isletNavigationText: any = 'Apply Now';
    dataNavigationText: any = 'Apply Now';
    onlineAppSession: any = '';
    get userSession() {
        return store.userSession;
    }
    get userInfo() {
        return store.userInfo;
    }
    get hasStudy() {
        return this.userInfo.study !== undefined;
    }
    get hasData() {
        return this.userInfo.data !== undefined;
    }
    mounted() {
        const onlineAppUrl = IIDPconfig.ONLINE_APP_URL as string;
        this.onlineAppSession = `${onlineAppUrl}/${IIDPconfig.ONLINE_SESSION_URL as string}`;
    }
    async created() {
        if (this.userSession != null && store.userSession != null) {
            // retrieving userInfo...
            const savedSession = JSON.parse(
                localStorage.getItem(store.userSession.userName) || '{}',
            );
            if (savedSession.rowId !== undefined && savedSession.rowId !== '') {
                const d = await client.get(
                    new UserInfo({
                        userName: this.userSession.userName,
                        rowId: savedSession.rowId,
                    }),
                );
                bus.$set(store, 'userInfo', d);

            } else {
                const d = await client.get(
                    new UserInfo({ userName: this.userSession.userName }),
                );
                bus.$set(store, 'userInfo', d);
            }
            const url = new URL(this.onlineAppSession);
            url.searchParams.append('u', this.userInfo.userInfo.userId);
            this.urlParameterText = url.href;
            if (this.hasStudy && this.userInfo.study.form !== undefined) {
                if (this.userInfo.study.form.moved !== undefined) {
                    if (this.userInfo.study.form.moved === true) {
                        this.isletNavigationText = 'View Submitted Application';
                    } else {
                        this.isletNavigationText = 'View In Progress Application';
                    }
                }
            }
            if (this.hasData && this.userInfo.data.form !== undefined) {
                if (this.userInfo.data.form.submitted1 === true) {
                    this.dataNavigationText = 'View Submitted Application';
                } else {
                    this.dataNavigationText = 'View In Progress Application';
                }
            }
        }

    }
}
